import script from "./UiTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTabs.vue?vue&type=script&setup=true&lang=js"

import "./UiTabs.vue?vue&type=style&index=0&id=5f8bf24a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8bf24a"]])

export default __exports__